/**
 * 聊天服務
 */
import { api, endpoints } from "@/infrastructure/api";
import { ChatMessage, FileIds } from "../models/chat";

/**
 * 聊天服務
 * 處理聊天訊息相關操作
 */
export const chatService = {
  /**
   * 獲取頁面的所有聊天訊息
   * @param sessionId 會話 ID
   * @returns 聊天訊息列表
   */
  async getPageChatMessages(sessionId: string): Promise<ChatMessage[]> {
    return await api.get<ChatMessage[]>(
      endpoints.chat.pageMessages(sessionId),
      {},
    );
  },

  /**
   * 發送頁面聊天訊息
   * @param sessionId 會話 ID
   * @param content 訊息內容
   * @returns 新創建的聊天訊息
   */
  async sendPageChatMessage(
    sessionId: string,
    content: string,
    message_metadata?: Record<string, any>,
  ): Promise<ChatMessage> {
    if (!sessionId) {
      throw new Error("發送頁面聊天訊息需要指定 sessionId");
    }
    return await api.post<ChatMessage>(endpoints.chat.pageMessages(sessionId), {
      role: "user",
      content,
      message_metadata,
    });
  },

  async uploadFile(sessionId: string, files: File[]): Promise<FileIds> {
    if (!files) {
      throw new Error("上傳檔案需要指定 files");
    }
    return await api.post<FileIds>(endpoints.chat.files(sessionId), files);
  },
};
